import {DashboardLayout} from "../../layout/dashboard.layout";
import {useTranslation} from "react-i18next";
import {DASHBOARD, GROUPS} from "../../../routes/frontend.routes";
import React, {useEffect, useState} from "react";
import {Link, useParams} from "react-router-dom";
import {jsonRequest} from "../../../../api/request/request";
import {GROUP_EDIT, GROUP_GET} from "../../../../api/routing/routes/admin.backend.app";
import {HttpException, UnprocessableEntityException} from "../../../../lib/http/exception/http.exception";
import {useAlert} from "react-alert";
import {useNavigate} from "react-router";
import {GroupForm} from "./form";
import {Group} from "../../../../api/model/group";

export const UpdateGroup = () => {
  const {t} = useTranslation();
  const alert = useAlert();
  const params = useParams();
  const id = params.id as string;

  const [isSubmitting, setSubmitting] = useState(false);
  const [errors, setErrors] = useState([]);
  const navigate = useNavigate();
  const [group, setGroup] = useState<Group>();

  const loadGroup = async () => {
    try {
      const res = await jsonRequest(GROUP_GET.replace(':id', id));
      const json = await res.json();

      setGroup(json.group);
    } catch (e) {
      if (e instanceof HttpException) {
        alert.error(e.message);
      }

      throw e;
    }
  }

  useEffect(() => {
    loadGroup();
  }, []);

  const onSubmit = async (values: any) => {
    setSubmitting(true);
    setErrors([]);

    try {
      await jsonRequest(GROUP_EDIT.replace(':id', id), {
        method: 'POST',
        body: JSON.stringify(values)
      });

      navigate(GROUPS);
    } catch (e) {
      if (e instanceof UnprocessableEntityException) {
        const err = await e.response.json();
        setErrors(err.violations);
      }

      if (e instanceof HttpException) {
        alert.error(e.message);
      }

      throw e;
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <DashboardLayout
      title="Groups"
      breadCrumbs={[
        {title: t('Dashboard'), link: DASHBOARD},
        {title: t('Groups'), link: GROUPS},
        {title: t('Update'), current: true},
      ]}
      buttons={[
        <Link to={GROUPS} className="float-end btn btn-primary">{t('Back to list')}</Link>
      ]}
    >
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">
                {t('Update')}
              </h5>
              <GroupForm
                onSubmit={onSubmit}
                isSubmitting={isSubmitting}
                errors={errors}
                group={group}
              />
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};
